<template>
	<div class="table-footer">
		<div class="row">
			<div class="col-md-4">
				<span>Show</span>
				<select
					class="form-control"
					v-model="showPerPage"
					id="resultsPerPage"
					@change="showPerPageChanged"
				>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
				<span>entries</span>
			</div>
			<div class="col-md-4 text-center">
				<!-- <span> Selected Ones</span>
                <button class="btn btn-danger" onclick="deleteCampaignGroup();">
                    <svg viewBox="0 0 8 8" class="icon fill-white">
                            <use
                            xlink:href="images/open-iconic.svg#trash"></use>
                        </svg>
                    Delete
				</button>-->
			</div>
			<div class="col-md-4 text-right">
				<a href="javascript:void(0)" v-if="currentPageNumber!=1" @click="getPreviousPageList()">Previous</a>
				<select
					class="form-control selectpicker"
					style="max-width:70px;padding:2px"
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option v-for="index in totalNoOfPages" :key="index" :value="index">{{index}}</option>
				</select>
				<a
					href="javascript:void(0)"
					v-if="(showPerPage == notificationList.length) && (currentPageNumber!=totalNoOfPages)"
					@click="getNextPageList()"
				>Next</a>
				<div style="padding-right:0px;padding-top:5px">{{getCount()}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CampaignGroupGridFooter",
		data() {
			return {
				totalNoOfPages: 1
			};
		},
		watch: {
			notificationCount() {
				this.calculateIndexPerPage();
			}
		},
		computed: {
			notificationCount: {
				set(val) {
					this.$store.commit("notification/updateNotificationCount",val);
				},
				get() {
					return this.$store.getters["notification/receiveNotificationCount"];
				}
			},
			showPerPage: {
				set(val) {
					this.currentPageNumber = 1
					sessionStorage.setItem("notification:showPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("notification:showPerPage")) {
						return sessionStorage.getItem("notification:showPerPage");
					}
					return this.$store.state.showPerPage;
				}
			},
			currentPageNumber: {
				set(val) {
					this.$store.state.currentPageNumber = val;
				},
				get() {
					return this.$store.state.currentPageNumber;
				}
			},
			notificationList() {
				return this.$store.state.notification.notificationList;
			}
		},
		mounted() {
			this.calculateIndexPerPage();
		},
		methods: {
			calculateIndexPerPage() {
				this.totalNoOfPages = Math.ceil(
					this.notificationCount / this.showPerPage
				);
			},
			getPreviousPageList() {
				if (this.currentPageNumber <= 1) {
					return;
				} else {
					this.currentPageNumber -= 1;
					this.$store.dispatch("notification/getNotificationList");
				}
			},
			getNextPageList() {
				this.currentPageNumber += 1;
				this.$store.dispatch("notification/getNotificationList");
			},
			getNewPageList() {
				this.$store.dispatch("notification/getNotificationList");
			},
			getCount() {
				let pageCount = this.showPerPage * (this.currentPageNumber - 1);
				let extendedcount =
					parseInt(pageCount) + parseInt(this.notificationList.length);
				//return	pageCount+1 + ' to ' + extendedcount;
				return (
					"Showing " +
					(pageCount + 1) +
					" to " +
					extendedcount +
					" results of " +
					this.notificationCount
				);
			},
			showPerPageChanged() {
				this.$store.dispatch("notification/getNotificationList");
			}
		}
	};
</script>

<style lang="scss">
</style>
